import { render, staticRenderFns } from "./BasicDetails.vue?vue&type=template&id=6c96b37c&scoped=true"
import script from "./BasicDetails.vue?vue&type=script&lang=js"
export * from "./BasicDetails.vue?vue&type=script&lang=js"
import style0 from "./BasicDetails.vue?vue&type=style&index=0&id=6c96b37c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c96b37c",
  null
  
)

export default component.exports